import React, { useState } from 'react';
import { Translate } from '../../shared/LanguageService';
import { Table, Button } from '@mui/material';
import IPhotographer from './IPhotographer';
import PhotographersListRow from './PhotographersListRow';
import SendEmailToPhotographersModal from './SendEmailToPhotographersModal';

interface IPhotographersListProps {
    photographers: IPhotographer[];
    edit: (id: number) => void;
    logs: (id: number) => void;
    showDiscontinued: boolean;
}

const PhotographersList = (props: IPhotographersListProps) => {
    const [showSendEmailToPhotographersModal, setShowSendEmailToPhotographersModal] = useState(false);
    const [photographersInRegion, setPhotographersInRegion] = useState<IPhotographer[]>([]);

    function getRegions(photographers: IPhotographer[]) {
        return photographers
            .map((p) => p.region)
            .filter((value, index, self) => self.indexOf(value) === index);
    }

    function filterPhotographer(photographer: IPhotographer) {
        if (props.showDiscontinued) {
            return true;
        }
        return !photographer.isDiscontinued;
    }

    function sortPhotographer(a: IPhotographer, b: IPhotographer) {
        return a.name.localeCompare(b.name);
    }

    function handleOpenSendEmailToPhotographersInRegionDialog(region: string) {
        const photographersInRegion = props.photographers.filter((p) => p.region === region && p.isDiscontinued === false);
        setPhotographersInRegion(photographersInRegion);
        setShowSendEmailToPhotographersModal(true);
    }

    return (
        <div>
            {getRegions(props.photographers)
                .sort((a, b) => a.localeCompare(b))
                .map((region) => {
                    return (
                        <div key={`region-${region.toLowerCase()}`} style={{ marginBottom: '20px' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <h2>{region}</h2>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={() => handleOpenSendEmailToPhotographersInRegionDialog(region)}
                                >
                                    {Translate('photographer/send-email-by-region/button-send-email')}
                                </Button>
                            </div>
    
                            <Table>
                                <thead>
                                    <tr>
                                        <th>{Translate('photographer/list/header/name')}</th>
                                        <th>{Translate('photographer/list/header/email-address')}</th>
                                        <th>{Translate('photographer/list/header/phone-number')}</th>
                                        <th>{Translate('photographer/list/header/cubicasa')}</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {props.photographers
                                        .filter((photographer) => photographer.region === region)
                                        .filter(filterPhotographer)
                                        .sort(sortPhotographer)
                                        .map((u: IPhotographer) => {
                                            return (
                                                <PhotographersListRow
                                                    photographer={u}
                                                    key={u.id}
                                                    edit={props.edit}
                                                    logs={props.logs}
                                                />
                                            );
                                        })}
                                </tbody>
                            </Table>
                        </div>
                    );
                })}
    
            <SendEmailToPhotographersModal
                open={showSendEmailToPhotographersModal}
                photographers={photographersInRegion}
                onClose={() => setShowSendEmailToPhotographersModal(false)}
            />
        </div>
    );
};

export default PhotographersList;